<p-fieldset legend="Relatório Mensal de Investimentos" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="investimentosMensais"></app-lista-arquivos>
</p-fieldset>
<p-fieldset legend="Relatório Anual de Investimentos" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="investimentosAnuais"></app-lista-arquivos>
</p-fieldset>
<p-fieldset legend="Composição da Carteira" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="composicaoCarteira"></app-lista-arquivos>
</p-fieldset>
<p-fieldset legend="Cronograma das atividades mensais do setor" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="planoAcaoMensalFinan"></app-lista-arquivos>
</p-fieldset>

<p-fieldset legend="Relatórios Trimestrais de Investimentos" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="relatoriostrifinanceiros"></app-lista-arquivos>
</p-fieldset>

<p-fieldset legend="Relatórios Semestrais de Diligência" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="relatoriosdilifinanceiros"></app-lista-arquivos>
</p-fieldset>
